var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rpage",on:{"click":_vm.back}},[_c('img',{attrs:{"src":require("../../assets/img/rPageIcon.png"),"alt":""}}),_vm._v(" 返回 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }